enum CanvasInputListenerModeEnum {
    RAYCAST_TARGET_OBJECTS,
    RAYCAST_PLANE
}

export default CanvasInputListenerModeEnum;